const {LitElement, html, unsafeHTML, ref, createRef} = window.globalLit;
import { buildSelectOptions } from '../../functions.js';
import BaseStepElement from './BaseStepElement.js';

customElements.define('expect-step', class ExpectStepElement extends BaseStepElement {

    render() {

        let innerHtml = null;
        let negate = '';
        if (this.value.negate) {
            negate = html`<strong>NOT</strong>`;
        }

        if (this.value.what === 'toHaveTitle') {
            innerHtml = html`
                <strong>Expect page to ${negate}</strong> have title
                    <input is="autogrow-input" type="text" 
                            placeholder="Title..."
                            ?readonly=${this.readonly}
                            value="${this.value.text}"
                            @input="${this._onChange.bind(this, 'text')}"
                            style="min-width: 40px; width: 40px;"
                            class="step__input bg-primary-subtle text-primary">
            `;
        }
        else if (this.value.what === 'toBeInViewport') {
            innerHtml = html`
                <strong>Expect</strong> 
                    <element-selector .value=${this.value.element} ?readonly=${this.readonly}
                        @selectorchange="${this._onChange.bind(this, 'element')}"></element-selector> 
                    <strong>to ${negate}</strong> be in viewport.
            `;
        }
        else if (this.value.what === 'toBeVisible') {
            innerHtml = html`
                <strong>Expect</strong> 
                    <element-selector .value=${this.value.element} ?readonly=${this.readonly}
                        @selectorchange="${this._onChange.bind(this, 'element')}"></element-selector> 
                    <strong>to ${negate}</strong> be visible.
            `;
        }
        else if (this.value.what === 'content') {
            innerHtml = html`
                <strong>Expect</strong> 
                    <element-selector .value=${this.value.element} ?readonly=${this.readonly}
                        @selectorchange="${this._onChange.bind(this, 'element')}"></element-selector> 
                        inner text
                    <strong>to ${negate}</strong> 
                    
                    &nbsp;
                    &nbsp;
                    
                    <select 
                        @change="${this._onChange.bind(this, 'comparison')}"
                        ?readonly=${this.readonly}
                        class="step__input bg-primary-subtle text-primary" style="width: fit-content; display: inline-block;">
                        ${unsafeHTML(buildSelectOptions(window.ComparisonList, this.value.comparison))}
                    </select>

                    to

                    <input is="autogrow-input" type="text" 
                        placeholder="value..."
                        ?readonly=${this.readonly}
                        value="${this.value.comparison_value}"
                        @input="${this._onChange.bind(this, 'comparison_value')}"
                        style="min-width: 40px; width: 40px;"
                        class="step__input bg-primary-subtle text-primary">

                    .
            `;
        } else {
            console.log('Unknown expect expectation', this.value.what)

        }
        
        return html`
            ${innerHtml}
        `;
    }

});
